// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preselect-date {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 3px 5px 3px 5px;
}

.preselect-date:hover {
  background-color: #E0EDFF;
  border: 1px solid #495CFF;
  color: #00000A;
  border-radius: 5px;
  transition: 0.3s;
}

.elc-separator-calendar-vertical {
  height: 300px;
  background-color: #d3d3d3;
  width: 1px;
}

.elc-separator-calendar-horizontal {
  width: 100%;
  background-color: #d3d3d3;
  height: 1px;
}

.elc-calendar-btn {
  border-radius: 5px;
  padding: 3px 9px;
}

.elc-calendar-btn:hover {
  border-color: #495CFF;
  background-color: #E0EDFF;
  color: #000;
}

.elc-calendar-others {
  background-color: #fff;
  border-color: #0A56AE;
  color: #0A56AE;
}

.elc-calendar-done {
  background-color: #0A56AE;
  color: #fff;
  border-color: #0A56AE;
}

.datepicker-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
  width: 100%;
}

.datepicker-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 20px;
  margin-left: 8px;
}

.datepicker-elc-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 8px;
}`, "",{"version":3,"sources":["webpack://./../dashboard/src/components/ELCDatePicker/ELCDatePicker.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,sBAAA;EACA,qBAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AACJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAAJ","sourcesContent":[".preselect-date {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding: 3px 5px 3px 5px;\n}\n\n.preselect-date:hover {\n    background-color: #E0EDFF;\n    border: 1px solid #495CFF;\n    color: #00000A;\n    border-radius: 5px;\n    transition: 0.3s;\n}\n\n.elc-separator-calendar-vertical {\n    height: 300px;\n    background-color: #d3d3d3;\n    width: 1px;\n}\n\n.elc-separator-calendar-horizontal {\n    width: 100%;\n    background-color: #d3d3d3;\n    height: 1px;\n}\n\n.elc-calendar-btn {\n    border-radius: 5px;\n    padding: 3px 9px;\n}\n\n.elc-calendar-btn:hover {\n    border-color: #495CFF;\n    background-color: #E0EDFF;\n    color: #000;\n}\n\n.elc-calendar-others {\n    background-color: #fff;\n    border-color: #0A56AE;\n    color: #0A56AE;\n}\n\n.elc-calendar-done {\n    background-color: #0A56AE;\n    color: #fff;\n    border-color: #0A56AE;\n}\n\n\n.datepicker-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    height: 100%;\n    width: 100%;\n}\n\n.datepicker-list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 20px;\n    margin-left: 8px;\n}\n\n.datepicker-elc-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 10px 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
